/* eslint no-prototype-builtins: "off" */

'use strict';

let registredEvents = {};

/**
 * Mediator is an event handler service, it can subscribe and publish event
 *
 * @module core/mediator
 * @author Florian Kroockmann <florian.kroockmann@lp-digital.fr>
 */
module.exports = {
  /**
   * Subscribe to an event
   *
   * @example mediator.subscribe('my-event', (data) => {console.log('hello world') });
   * @param  {string}   eventName
   * @param  {Function} callback
   * @param  {boolean}  once
   */
  subscribe: function(eventName, callback, once = false) {
    registredEvents[eventName] = registredEvents[eventName] || [];

    registredEvents[eventName].push({'callback': callback, 'once': once});
  },

  /**
   * Publish an event
   *
   * @example mediator.publish('my-event', {country: 'France'});
   * @param  {string} eventName
   * @param  {object} [params] params
   * @param  {string} [context] context
   */
  publish: function(eventName, params, context) {
    let events = registredEvents[eventName] || [];

    events.forEach((event) => {
      if (event) {
        event.callback.call(context, params);
        if (event.once) {
          registredEvents[eventName] = events.find((element) => element !== event);
        }
      }
    });
  },

  /**
   * Remove events from the mediator
   * @example mediator.clear('my-event');
   * @example mediator.clear(['my-event', 'my-event2']);
   * @example mediator.clear();
   * @param  {object | string} events
   */
  clear: function(events = []) {
    if (typeof events === 'string') {
      events = [events];
    }

    if (events.length) {
      for (let key in events) {
        if (events.hasOwnProperty(key)) {
          delete registredEvents[events[key]];
        }
      }
    } else {
      registredEvents = {};
    }
  },
};
